var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMove = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    fillRule: "evenodd",
    d: "M3.334 8.667h7.91l-2.422 2.906c-.236.283-.198.704.085.939.283.236.703.197.94-.085l3.333-4c.026-.032.038-.068.058-.103.016-.028.035-.052.047-.083.03-.076.048-.157.048-.238V8v-.003c0-.081-.018-.162-.048-.238-.012-.031-.031-.055-.047-.083-.02-.035-.032-.071-.058-.103l-3.334-4c-.132-.158-.322-.24-.512-.24-.151 0-.302.051-.427.155-.283.235-.321.656-.085.939l2.422 2.906h-7.91c-.368 0-.667.299-.667.667 0 .368.299.667.667.667z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMove, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/move.dbce3e3f.svg";
export { ForwardRef as ReactComponent };